import React from 'react';
import { stateNameToAbbrev } from 'utils/stateAbbreviations';

export enum IconSize {
  SMALL = 20,
  MEDIUM = 24,
}

// Map for predefined size CSS classes
const SIZE_CLASS_MAP = new Map<number, string>([
  [IconSize.SMALL, 'size-20'],
  [IconSize.MEDIUM, 'size-24'],
]);

interface MiniStateIconProps {
  stateName: string;
  size: IconSize;
}

const MiniStateIcon = ({
  stateName,
  size = IconSize.MEDIUM,
}: MiniStateIconProps) => {
  const stateAbbrev = stateNameToAbbrev[stateName];

  const sizeClass = SIZE_CLASS_MAP.get(size)!;
  const className = `mini-state-icon ${sizeClass}`;

  return (
    <div className={className} title={stateName}>
      {stateAbbrev}
    </div>
  );
};

export default MiniStateIcon;
